module.exports = __webpack_public_path__ + "img/Boulangerie_2.8130c2b0.jpg";